import { render, staticRenderFns } from "./comFooter.vue?vue&type=template&id=1376d662&scoped=true"
import script from "./comFooter.vue?vue&type=script&lang=js"
export * from "./comFooter.vue?vue&type=script&lang=js"
import style0 from "./comFooter.vue?vue&type=style&index=0&id=1376d662&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1376d662",
  null
  
)

export default component.exports